import React, { useState, useEffect } from 'react';
import { Select, TextInput, Stack, Button } from '@mantine/core';
import { ActiveFilter, FilterRendererProps } from '../../types';

const NumberFilterForModal: React.FC<FilterRendererProps> = ({
  filterConfig,
  filterName,
  selectedCategory,
  localActiveFilters,
  setLocalActiveFilters,
  onCountUpdate,
}) => {
  const filterObject = filterConfig.filterObject || 'evidence';

  const existingFilter = localActiveFilters.find(
    (filter: any) => filter.name === filterName && filter.filterObject === filterObject
  );
  const appliedValue = existingFilter?.selected?.[0] || '';
  const appliedOperator = existingFilter?.operator || null;

  // Draft state: only committed to localActiveFilters when user clicks Apply
  const [draftOperator, setDraftOperator] = useState<string | null>(appliedOperator);
  const [draftValue, setDraftValue] = useState(appliedValue);

  // Sync draft from applied filters when they change (e.g. clear, or open modal)
  useEffect(() => {
    setDraftOperator(appliedOperator);
    setDraftValue(appliedValue);
  }, [appliedOperator, appliedValue]);

  const handleApply = () => {
    if (!draftOperator || !draftValue?.trim()) {
      // Remove filter if no value or no operator
      setLocalActiveFilters((prev: any) =>
        prev.filter((filter: any) => !(filter.name === filterName && filter.filterObject === filterObject))
      );
      onCountUpdate?.(0);
      return;
    }

    const updatedFilter: ActiveFilter = {
      ...filterConfig,
      name: filterName,
      filterObject: filterObject as 'evidence' | 'idea',
      selected: [draftValue.trim()],
      operator: draftOperator,
      query: Number(draftValue.trim()),
      options: undefined,
    };

    setLocalActiveFilters((prev: any) => {
      const existingIndex = prev.findIndex(
        (filter: any) => filter.name === filterName && filter.filterObject === filterObject
      );
      if (existingIndex >= 0) {
        const next = [...prev];
        next[existingIndex] = updatedFilter;
        return next;
      }
      return [...prev, updatedFilter];
    });
    onCountUpdate?.(1);
  };

  const operatorOptions = filterConfig.operations?.length
    ? filterConfig.operations
    : [
      { value: 'equal', label: 'Equals' },
      { value: 'greater_than', label: 'Greater than' },
      { value: 'lower_than', label: 'Less than' },
      { value: 'not_equal', label: 'Not equal' },
    ];

  return (
    <Stack spacing="xs" sx={{ maxWidth: 200 }}>
      <Select
        placeholder="Select operator"
        value={draftOperator}
        onChange={(value) => setDraftOperator(value)}
        data={operatorOptions}
        size="sm"
      />
      <TextInput
        placeholder="Enter value"
        value={draftValue}
        onChange={(event) => setDraftValue(event.currentTarget.value)}
        type="number"
        size="sm"
      />
      <Button 
        size="sm" 
        onClick={handleApply}
        sx={{ width: '140px',
          backgroundColor: '#635fe2',
          '&:hover':
          { backgroundColor: '#5550c7' } }}>
        Apply
      </Button>
    </Stack>
  );
};

export default NumberFilterForModal;
